<template>
    <div class="row" style="margin-top:30px">
        <div class="col-12 mb-4" style="height: auto"  v-if="hasFunzionalita(2)">
            <div class="card shadow  "  style="margin-top:20px;background:#fff;">
                <div class="card-body" >
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#0597F2">EMMET <small><small>v. {{ $root.VERSIONE }}</small></small></div>  
                            <div class="h3 mb-0  " style="color:#0597F2" >Gestionale documentale per l'Univesità agraria di Monte Romano</div> 
                            <button class="btn btn-primary mt-2" v-on:click="openModulo('dashamm')"><i class="fad fa-cogs"></i> Amministrazione</button>
                        </div>
                        <div class="col-auto">
                            <img src="~@\assets\img\logo.jpg"  style="margin: 0 auto;max-height:140px" class="img-responsive d-none d-sm-block">
                        </div>
                    </div>
                </div>
            </div>        
        </div>

        <div class="col-4  mt-4" style=""  v-if="hasFunzionalita(3)" >
            <div class="card shadow lift-panel "  v-on:click="openModulo('Pratiche')" style="margin:0 auto; margin-top:20px;background: #fff !important;width:260px;height:260px">
                <div class="card-body text-center" >
                    <i class="mt-4 fad fa-folders fa-6x" style="color:#ffad69"></i><br/>
                    <div class="font-weight-bold mb-1 h3 mt-4" style="color:#0597F2 !important">Pratiche</div>  
                </div>
            </div>        
        </div>

        <div class="col-4 mt-4" style=""  v-if="hasFunzionalita(3)" >
            <div class="card shadow lift-panel "  v-on:click="openModulo('Protocollo')" style="margin:0 auto; margin-top:20px;background: #fff !important;width:260px;height:260px">
                <div class="card-body text-center" >
                    <i class="mt-4 fas fa-stamp fa-6x" style="color:#a9a9a9"></i><br/>
                    <div class="font-weight-bold mb-1 h3 mt-4" style="color:#0597F2 !important">Protocollo</div>  
                </div>
            </div>        
        </div>

        <div class="col-4 mt-4" style=""  v-if="hasFunzionalita(3)" >
            <div class="card shadow lift-panel "  v-on:click="openModulo('PersoneFisiche')" style="margin:0 auto;margin-top:20px;background: #fff !important;width:260px;height:260px">
                <div class="card-body text-center" >
                    <i class="mt-4 fad fa-id-card fa-6x" style="color:#226636"></i><br/>
                    <div class="font-weight-bold mb-1 h3 mt-4" style="color:#0597F2 !important">Persone</div>  
                </div>
            </div>        
        </div>

        <div class="col-4 mt-4" style=""  v-if="hasFunzionalita(3)" >
            <div class="card shadow lift-panel "  v-on:click="openModulo('PersoneGiuridiche')" style="margin:0 auto;margin-top:20px;background: #fff !important;width:260px;height:260px">
                <div class="card-body text-center" >
                    <i class="mt-4 fad fa-university fa-6x" style="color:#314E8C"></i><br/>
                    <div class="font-weight-bold mb-1 h3 mt-4" style="color:#0597F2 !important">Società/Enti</div>  
                </div>
            </div>        
        </div>

        <div class="col-4  mt-4" style=""  v-if="hasFunzionalita(3)" >
            <div class="card shadow lift-panel "  v-on:click="openModulo('Terreni')" style="margin:0 auto; margin-top:20px;background: #fff !important;width:260px;height:260px">
                <div class="card-body text-center" >
                    <i class="mt-4 fas fa-tractor fa-6x" style="color:#258C08"></i><br/>
                    <div class="font-weight-bold mb-1 h3 mt-4" style="color:#0597F2 !important">Terreni</div>  
                </div>
            </div>        
        </div>
<!--
        <div class="col-4 mt-4" style=""  v-if="hasFunzionalita(3)" >
            <div class="card shadow lift-panel "  v-on:click="openModulo('Utenti')" style="margin:0 auto;margin-top:20px;background: #fff !important;width:260px;height:260px">
                <div class="card-body text-center" >
                    <i class="mt-4 fad fa-users-cog  fa-6x" style="color:#36b9cc"></i><br/>
                    <div class="font-weight-bold mb-1 h3 mt-4" style="color:#0597F2 !important">Utenti</div>  
                </div>
            </div>        
        </div>

-->
 
      <!-- 
        <div class="col-4" style=""  v-if="hasFunzionalita(3)" >
            <div class="card shadow lift-panel "  v-on:click="openModulo('dashamm')" style="margin-top:20px;background: #A76549!important;">
                <div class="card-body" >
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h3" style="color:#fff !important">Amministrazione</div>  
                            <div class="h5 mb-0  " style="color:#fff" >Gestione Amministrazione</div> 
                        </div>
                        <div class="col-auto">
                            <i class="fad fa-cogs fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>        
        </div>
        -->

    </div>

<!--
    <input type="text" class="form-control" v-model="tabella"><button class="btn btn-info" v-on:click="creaTabella()">Crea tabella</button>
-->
</template>
<script>


export default {
    name:"Dashboard",
    components: {
      
    },
    data:function(){
      return{
        utente:{},
        tabella:"",
        dataUltimoOrdine:"",
        filters:global.filters
      }
    },
    methods:{
        openModulo : function(modulo){
            global.router.push(modulo);
        },
        hasFunzionalita : function(id){
            for (var i = 0 ; i < this.$root.utente.funzionalita.length ; i++){
                if (this.$root.utente.funzionalita[i].ID_FUNZIONALITA == id){
                    return true;
                }
            }
            return false;
        },
    },
    computed:{
        
    },
    created: function () {
        global.utils.ajax('core/home',{}, (response) => {
            this.$root.arrayTipologiePratica = response.data.TIPOLOGIE_PRATICA;
        });  
    },
}
</script>